<template>
  <el-dialog
    @open="onOpen"
    title="Relatórios de Comissões - Venda"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="30%"
  >
    <el-form
      :model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Relatório">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable 
              placeholder=""
              style="width: 100%;">
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>
      
      <span v-if="exibirCampos">Período</span>
      <el-row :gutter="10" v-if="exibirCampos">
        <el-col :span="11">
          <el-form-item label="" prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p></p>
          <span>a</span>
        </el-col>
        <el-col :span="11">
          <el-form-item label="" prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="exibirCampos">
        <el-col>
          <el-form-item label="Proprietário" style="width: 100%">
              <el-select v-model="relatorio.cliente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="relatorio.cliente = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                  v-for="item in clientesDisponiveis"
                  :key="item.id"
                  :label="formatarSelectCliente(item)"
                  :value="item">
              </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCamposSomenteCorretorImobiliaria">
        <el-col>
          <el-checkbox v-model="relatorio.exibirSomenteComissaoImobiliaria">Exibir Somente as Comissões da Imobiliária</el-checkbox>
        </el-col>
      </el-row>

      <el-row v-if="exibirCamposSomenteCorretor">
        <el-col>
          <el-checkbox v-model="relatorio.exibirComissaoImobiliaria">Exibir as Comissões da Imobiliária</el-checkbox>
        </el-col>
      </el-row>

      <p/>

      <el-row :gutter="20" v-if="exibirCamposCorretor">
        <el-col>
          <el-form-item label="Corretor">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirCampos">
        <el-col>
          <el-form-item label="Ordenação:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.ordenacao" style="font-size: small;">
              <el-row>
                <el-col>
                  <el-radio label="PADRAO" style="margin-top:5px">Padrão</el-radio>
                </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-radio label="DATA_PAGAMENTO" v-if="(this.relatorio.nome === 'RELATORIO_DE_COMISSOES_PAGAS')" style="margin-top:5px">Data de Pagamento</el-radio>
                </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-radio label="DATA_VENDA" v-if="(this.relatorio.nome === 'RELATORIO_DE_COMISSOES')" style="margin-top:5px">Data de Venda</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>           

    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import funcoes from '../../../util/funcoes.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      tiposRelatorios: 
      [{
          value: 'RELATORIO_DE_COMISSOES',
          label: 'Relatório de Comissões a Pagar'
        }, {
          value: 'RELATORIO_DE_COMISSOES_PAGAS',
          label: 'Relatório de Comissões Pagas'
      }],
      relatorio: {
        nome: undefined,
        cliente: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        exibirSomenteComissaoImobiliaria: false,
        exibirComissaoImobiliaria: false,
        ordenacao: 'PADRAO'
      },

      loadingClientes: false,
      loadingUsuarios: false
    }
  },
  watch:{
    'relatorio.nome': function(newV, oldV){
      if(newV !== oldV){
        this.relatorio.ordenacao = 'PADRAO'
      }
    }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) { return state.usuarioLogado.permissoes; }
    }),
    ...mapState('vendasRelatoriosStore', {
      usuariosDisponiveis(state) { return state.usuariosDisponiveis },
      clientesDisponiveis(state) { return state.clientesDisponiveis }
    }),      
    exibirCampos() {
      return this.relatorio.nome;
    },
    exibirCamposCorretor() {
      return this.relatorio.nome && !this.relatorio.exibirSomenteComissaoImobiliaria;
    },
    exibirCamposSomenteCorretorImobiliaria() {
      const exibir = this.permissoes.filter(
        (permissao) => { 
        return permissao.modulo == "RELATORIOS_COMISSOES_VENDA" })[0]
      if(!exibir) {
        return false;
      }
      return exibir.visualizacao && this.relatorio.nome && !exibir.visualizacaoSomenteComissoesCorretor
    },
    exibirCamposSomenteCorretor() {
      const exibir = this.permissoes.filter((permissao) => { return permissao.modulo == "RELATORIOS_COMISSOES_VENDA" })[0]
      if(!exibir) {
        return false;
      }
      return exibir.visualizacao && this.relatorio.nome && !this.relatorio.exibirSomenteComissaoImobiliaria && !exibir.visualizacaoSomenteComissoesCorretor
    }
  },
  methods: {
  ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasRelatoriosStore", ["gerarRelatorio", "listarUsuarios", "listarClientes"]),

    onOpen() {
      this.relatorio.nome = undefined;
    },

    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        cliente: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        exibirSomenteComissaoImobiliaria: false,
        exibirComissaoImobiliaria: false,
        ordenacao: 'PADRAO'
      }
    },

    gerar() {
      this.showLoading();
      this.gerarRelatorio(this.relatorio)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
            case "FALHA":
              this.$message.warning("Ocorreu um erro ao gerar o relatório");
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível comunicar-se com o servidor");
        }).finally(() => {
          this.hideLoading();
        });
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
    },
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    fechar() {
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
  }
}
</script>

<style scoped>
.form-item {
    width: 100%; 
}
.select {
  font-size: 50%;
}
</style>